import { render, staticRenderFns } from "./ReviewModifyBookAndChapter.vue?vue&type=template&id=78aeedf1"
import script from "./ReviewModifyBookAndChapter.vue?vue&type=script&lang=js"
export * from "./ReviewModifyBookAndChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports